import { MediaType } from '@/@types';
import configuration from '@/configuration';
import React from 'react';

const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement> & { media?: MediaType[] }> = ({ src, media, alt, ...props }) => {
  let source: string | undefined = '';
  if (media) {
    source = media.find((x) => {
      return x.type === 'image';
    })?.source;
  }
  source = (src || '').startsWith('/') ? `${configuration.host}${src}` : src;
  return <img {...props} src={source} alt={alt} />;
};

export default Image;
